import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
let SearchTableService = class SearchTableService {
    containerHeight = new BehaviorSubject(0);
    containerHeightAsObservable = this.containerHeight.asObservable();
    propertySearchOptions = new BehaviorSubject([]);
    propertySearchOptionsAsObservable = this.propertySearchOptions.asObservable();
    preSelectedSearchOption = new BehaviorSubject("");
    preSelectedSearchOptionAsObservable = this.preSelectedSearchOption.asObservable();
    constructor() {
    }
    setPreSelectedSearchOption(preSelected) {
        this.preSelectedSearchOption.next(preSelected);
    }
    setPropertySearchOptions(options) {
        this.propertySearchOptions.next(options);
    }
    changeContainerHeight(height) {
        this.containerHeight.next(height);
    }
    static ctorParameters = () => [];
};
SearchTableService = __decorate([
    Injectable({
        providedIn: "root"
    })
], SearchTableService);
export { SearchTableService };
